import subscriptionReducer, {
  SUBSCRIPTION_REDUCER_KEY,
} from './subscriptionReducer';

export { SUBSCRIPTION_REDUCER_KEY };

export default subscriptionReducer;
